import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'jalali-moment';

@Pipe({
  name: 'shamsiDate'
})
export class JalaliTimesPipe implements PipeTransform {

  transform(value: any,  args?: any): any {
    return moment(value).format(args);
  }
// jYYYY/jMM/jDD hh:mm
// jD jMMMM jYYYY [ساعت] LT
//"item | shamsiDate:'jYYYY/jMM/jDD'"
}
